<template>
    <v-dialog
        v-model="dialog"
        width="500"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                class="text--main-yellow px-0 px-md-3"
                text
                v-bind="attrs"
                v-on="on"
                small
            >
                <span v-if="!btnText">{{ $t('choose') }}</span> <span class="text--main-yellow" v-if="btnText">{{ btnText }}</span>
            </v-btn>
        </template>

        <v-card>
            <v-card-title class="justify-center py-4">
                {{ $t('arriveDate') }}
            </v-card-title>
            <v-card-text class="justify-center text-center">
                {{ `${$t('selectDateDelivery')} ${sellerType}`}}<br>
                {{ orderSeller }}
            </v-card-text>
            <v-card-text class="justify-center">
                <v-radio-group column v-model="dateValue" class="text-center justify-center width-300">
                    <v-radio
                        :label="$t('asSoonPossible')"
                        :value="-1"
                        color="orange lighten-2"
                        class="px-0 pb-3 ma-0"
                        @click.native="picker = null"
                    ></v-radio>
                    <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        :return-value.sync="picker"
                        :nudge-right="100"
                        transition="scale-transition"
                    >
                        <template v-slot:activator="{ on }">
                            <div @click="menu = !menu">
                                <v-radio
                                    :label="dateLabel"
                                    :value="picker"
                                    v-on="on"
                                    color="orange lighten-2"
                                    class="pa-0 ma-0"
                                ></v-radio>
                            </div>
                        </template>
                        <v-date-picker
                            v-model="picker"
                            header-color="orange lighten-2"
                            color="orange lighten-2"
                            :locale="language"
                            width="300"
                            :min="currentDate"
                        >
                            <v-spacer></v-spacer>
                            <v-btn text color="orange lighten-2" @click="savePicker">{{ $t('choose') }}</v-btn>
                        </v-date-picker>
                    </v-menu>
                </v-radio-group>
            </v-card-text>
            <v-card-actions class="justify-center pb-6">
                <v-btn
                        depressed
                        class="main--yellow white--text"
                        @click="dialog = false"
                >
                    {{ $t('save') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import OrderBackup from "../../../../app-front/mixins/OrderBackup"

    export default {
        name: "DeliveryDate",
        props: ['dialogData'],
        mixins: [OrderBackup],
        data() {
            return {
                dialog: false,
                dateValue: null,
                picker: null,
                menu: false,
                currentDate: new Date().toISOString().substr(0, 10),
            }
        },
        computed: {
            btnCss() {
                return this.dateValue ? 'text--main-yellow' : 'grey--text text-lighten-2';
            },
            btnText() {
                if (!this.dateValue) return null;

                if (this.dateValue === -1) return this.$t('asSoonPossible');
                if (this.dateValue === 1) return null;

                return this.dateValue.split('-').reverse().join('.');
            },
            dateLabel() {
                let label = this.$t('selectDate');

                return label;
            },
            orderSeller() {
                return this.dialogData.companyName || `${this.dialogData.lastName} ${this.dialogData.firstName}`
            },
            sellerType() {
                return this.dialogData.companyName ? this.$t('fromCompany') : this.$t('fromSeller');
            },
            language() {
                if (this.$store.state.language.appLanguage === 'ua') {
                    return 'uk';
                }
                if (this.$store.state.language.appLanguage === 'ru') {
                    return 'ru';
                }
            }

        },
        methods: {
            dateChange() {
                this.$emit('date-change', this.dateValue);
            },
            savePicker() {
                this.$refs.menu.save(this.picker);
                this.menu = false;
                this.dialog = false;
            },
            setInitial() {
                if(!this.dialogData || !this.dialogData.id) return false;

                const backupSeller = this.backupGet().find(item => item.sellerID === this.dialogData.id);

                if(!backupSeller) return false;

                this.dateValue = backupSeller.date;
                this.dateChange();
            },
        },
        mounted() {
            this.setInitial();
        },
        watch: {
            picker() {
                this.dateValue = this.picker && this.picker !== 1 ? this.picker : null;
            },
            dialog() {
                if (!this.dialog) this.dateChange();
            }
        },
    }
</script>

<style scoped>

</style>
